import { route } from "react-router-typesafe-routes/dom";

export const userLocations = route(
  "user",
  {},
  {
    Dashboard: route("dashboard"),
  }
);
